import TagHandler from '../components/TagHandler.jsx';

function ProjectList() {
  return (
    <>
      <div className="project-list-wrapper">
        <div className="tag-handler-wrapper">
          <TagHandler />
        </div>
      </div>
    </>
  );
}

export default ProjectList;
